module.exports = __webpack_public_path__ + "img/palm-kid.29c2bbc6.jpg";